import type { OrganizationPrivacy } from 'models';
import { Card, DetailsCategoryItem, Icon } from 'ui';
import { useGetOrganizationPrivacyInformation } from './hooks';

type P = { privacy: OrganizationPrivacy };

const OrganizationDetailsCard = ({ privacy }: P) => {
  const privacyInformation = useGetOrganizationPrivacyInformation({ privacy });

  return (
    <Card title={<Card.Title icon={<Icon icon="information-line" />}>Details</Card.Title>}>
      <DetailsCategoryItem
        category="Privacy"
        description={privacyInformation.description}
        icon={privacyInformation.icon}
        name={privacyInformation.name}
      />
    </Card>
  );
};

export default OrganizationDetailsCard;
